import script from "./ComNimikeMuokkausLisaaOminaisuus.vue?vue&type=script&lang=ts&setup=true"
export * from "./ComNimikeMuokkausLisaaOminaisuus.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__